/**
 * Número grande com rótulo e dica — o mesmo desenho dos indicadores dos
 * Relatórios (feature não importa de feature, então o visual é repetido aqui).
 */
export default function Indicador({ rotulo, valor, dica, icone: Icone, destaque, e2e }) {
  return (
    <div className={`rounded-xl border p-4 ${destaque || "bg-card"}`} data-e2e={e2e}>
      <div className="flex items-center justify-between gap-2">
        <p className="text-[11px] uppercase tracking-wide text-muted-foreground">{rotulo}</p>
        {Icone && <Icone className="w-4 h-4 text-muted-foreground" />}
      </div>
      <p className="text-2xl font-black tabular-nums mt-0.5 leading-tight">{valor}</p>
      {dica && <p className="text-[11px] text-muted-foreground truncate mt-0.5">{dica}</p>}
    </div>
  );
}
